export default IconPodium => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-podium" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 8h14l-.621 2.485a2 2 0 0 1 -1.94 1.515h-8.878a2 2 0 0 1 -1.94 -1.515l-.621 -2.485z" />
  <path d="M7 8v-2a3 3 0 0 1 3 -3" />
  <path d="M8 12l1 9" />
  <path d="M16 12l-1 9" />
  <path d="M7 21h10" />
</svg>`;